// Extensions expected when the user drops individual files (not a .zip).
// The .prj is required so we can validate CRS before parsing.
export const REQUIRED_EXTENSIONS = ['shp', 'shx', 'dbf', 'prj'] as const;

// Substrings we look for in the WKT PRJ content to classify the file as
// WGS84. We intentionally only match on simple token presence — a full WKT
// parser would be overkill, and shapefiles written by agricultural tooling
// consistently include at least one of these tokens.
export const WGS84_WKT_MARKERS = [
    'GCS_WGS_1984',
    'WGS_1984',
    'WGS 84',
    'WGS_84',
    '"WGS 84"',
    'EPSG","4326',
    'EPSG","4269'
] as const;

// DBF columns we filter out when suggesting candidates for the rate field.
// These are conventional shapefile metadata columns added by ArcGIS / QGIS /
// John Deere exports and never contain agronomic rates.
export const COLUMN_NAME_EXCLUDES = [
    'OBJECTID',
    'FID',
    'Shape_Length',
    'Shape_Area',
    'SHAPE_LEN',
    'SHAPE_AREA'
] as const;

// Minimum required file set for the individual-files upload path.
export const MIN_FILE_SET_SIZE = REQUIRED_EXTENSIONS.length;

export const ZIP_EXTENSION = 'zip';
